import { color } from "src/styles/globals";
import { down } from "styled-breakpoints";
import styled from "styled-components";
import { Container } from "sunday-component";

export const Header = styled.header``;

export const HeaderContainer = styled(Container)`
  height: 120px;
  background-color: white;
  position: relative;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${color.charcoal03};
  z-index: 30;
  @media only screen and (max-width: 767px) {
    height: 56px;
  }
  @media only screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {
    height: 56px;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    height: 56px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoContainer = styled.div`
  width: fit-content;
  margin-right: 72px;
  ${down("md")} {
    margin: 0px;
  }
`;
